"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const CheckboxIcon_1 = require("./CheckboxIcon");
const DEFAULT_ICON_SIZE = 16;
const ICON_LABEL_VERTICAL = 'vertical';
const ICON_LABEL_HORIZONTAL = 'horizontal';
const Checkbox = (props) => {
    const { checked, children, className, custom = false, defaultChecked, disabled = false, error = false, icon = '', iconLabelPosition = ICON_LABEL_VERTICAL, iconSize = DEFAULT_ICON_SIZE, id = props.name, indeterminate = false, inline = false, inputRef, label, name, onChange = noop_1.default, onClick = noop_1.default, required = false, right, size, tabIndex = 0 } = props, remainingProps = tslib_1.__rest(props, ["checked", "children", "className", "custom", "defaultChecked", "disabled", "error", "icon", "iconLabelPosition", "iconSize", "id", "indeterminate", "inline", "inputRef", "label", "name", "onChange", "onClick", "required", "right", "size", "tabIndex"]);
    const labelRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        const input = (_a = labelRef.current) === null || _a === void 0 ? void 0 : _a.firstChild;
        if (input) {
            input.indeterminate = indeterminate;
        }
    }, [indeterminate, labelRef.current]);
    const handleToggleKeyDown = (event) => {
        switch (event.key) {
            case ' ':
                // toggle on space
                toggle(event);
                break;
            case 'Enter':
                // open on enter
                toggle(event);
                break;
            default:
                break;
        }
    };
    const toggle = (event) => {
        var _a;
        event.preventDefault();
        if (disabled) {
            return;
        }
        const input = (_a = labelRef.current) === null || _a === void 0 ? void 0 : _a.firstChild;
        if (input.indeterminate) {
            input.indeterminate = false;
        }
        input.checked = !input.checked;
        onClick(event);
        onChange(event);
    };
    const text = label || children;
    const labelClassnames = (0, classnames_1.default)('checkbox', inline && 'checkbox-inline', size === 'large' && 'checkbox-large', right && 'checkbox-right', className);
    const inputClassnames = (0, classnames_1.default)(error && 'error', size === 'large' && 'large', indeterminate && 'indeterminate', className);
    const renderCustomIcon = !!icon;
    const renderCustomContent = custom && children;
    const renderDefault = !icon && !custom;
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({}, remainingProps, { className: labelClassnames, tabIndex: tabIndex, htmlFor: id, onKeyDown: handleToggleKeyDown, ref: labelRef }, { children: [(0, jsx_runtime_1.jsx)("input", { id: id, name: name, type: 'checkbox', checked: checked, required: required, defaultChecked: defaultChecked, disabled: disabled, className: inputClassnames, onClick: onClick, onChange: onChange, ref: inputRef }), renderCustomIcon && ((0, jsx_runtime_1.jsx)(CheckboxIcon_1.CheckboxIcon, { icon: icon, iconSize: iconSize, iconLabelPosition: iconLabelPosition, text: text })), renderDefault && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'checkbox-text' }, { children: (0, jsx_runtime_1.jsx)("span", { children: text }) }))), renderCustomContent && children] })));
};
Checkbox.ICON_LABEL_VERTICAL = ICON_LABEL_VERTICAL;
Checkbox.ICON_LABEL_HORIZONTAL = ICON_LABEL_HORIZONTAL;
exports.default = Checkbox;
